export const CellPhoneCountryCodeOptions = ['+1', '+44', '+27'] as const
export type CellPhoneCountryCode = (typeof CellPhoneCountryCodeOptions)[number]

export interface PhoneNumberFormValues {
  cellPhoneNumber: string
  cellPhoneCountryCode: CellPhoneCountryCode
}
